import { useSelector } from 'react-redux';
import { getUnreadCount } from '../selectors';

/**
 * Returns the total unread message count from the Redux store.
 * The count is kept in sync by the UnreadCount component (header)
 * and SyncUnreadToRedux (student network prefetch).
 */
export function useUnreadMessageCount(): number {
    return useSelector(getUnreadCount);
}
